module.exports = __webpack_public_path__ + "img/sa.b3f0ecc3.svg";